module.exports = __webpack_public_path__ + "static/media/sort-circle-down.2c0d901e.svg";